export function getShouldBeDisabled(...items) {
  for (const item of items) {
    if (item && item.length) {
      return false;
    }
  }
  return true;
}
